<template>
<div>
  <div
      v-if="pageLoader"
      style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; padding-top: 25%; background-color: rgba(255, 255, 255, 0.31);"
  >
    <div class="text-xs-center">
      <v-progress-circular
          :size="70"
          :width="7"
          indeterminate
          color="#ff9233"
          class="text-xs-center my-5"
          large
      ></v-progress-circular>
    </div>
  </div>
  <v-container fluid grid-list-md class="padding_10" v-else>
    <v-expansion-panel class="mb-4">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Filters</div>
        </template>
        <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">
          <v-flex lg5 md12 sm12>
            <v-text-field
                v-model="filters.rakeNumber"
                append-icon="mdi-magnify"
                label="Enter rake number to search. Eg: 2201"
                single-line
                hide-details
                clearable
                solo
                :search-input.sync="search_name"
                v-on:keyup.enter="getRakeList()"
                :disabled="searchingNumber == true"
            ></v-text-field>
          </v-flex>
          <v-flex lg4 md12 sm12>
            <v-autocomplete
                label="Search For Agency Code"
                v-model="filters.agency_code"
                :items="agency_code"
                item-text="agency_code"
                item-value="agency_code"
                chips
                clearable
                name="name"
                @select="getRakeList()"
                solo
                :disabled="searchingItem == true"
            ></v-autocomplete>
          </v-flex>

          <v-flex lg3 md12 sm12>
            <v-autocomplete
                label="Search For Carshed"
                v-model="filters.Carshed"
                :items="base_location"
                item-text="carshed"
                item-value="carshed"
                chips
                clearable
                name="name"
                @select="getRakeList()"
                solo
                :disabled="searchingItem == true"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-layout row wrap class="table_opacity_8">
      <v-flex xs12>
        <v-data-table
            :items="list"
            item-key="id"
            class="elevation-1"
            :loading="loaders.rake_list"
            loading-text="Loading... Please wait"
            no-results-text="Loading... Please wait"
            :headers="headers1"
            v-model="selected"
            :pagination.sync="pagination"
            :total-items="total_items"
            :rows-per-page-items="[10, 20, 50, 100]">

          <template v-slot:items="props">
           <tr>
            <td>
              <router-link
                  :to="{ name: 'rake-tracking-details', params: { id: props.item.rake_number }}">
                {{ props.item.rake_number }}
              </router-link>
            </td>

            <td>
              {{ props.item.carshed }}
            </td>

            <td>
              {{ props.item.rake_address }}
            </td>

            <td>
              <span v-if="props.item.train_status == '1'">{{ "Running" }}</span>
              <span v-else-if="props.item.train_status == '0'">{{ "Stopped" }}</span>
              <span v-else>{{ " - " }}</span>
            </td>
             <td>
              <span v-if="props.item.tracking_time != '-'">
                {{
                  moment
                      .duration(
                          moment(props.item.tracking_time, "YYYY/MM/DD HH:mm:ss").diff(
                              moment().format("YYYY/MM/DD HH:mm:ss")
                          )
                      )
                      .humanize()
                }}
                {{ " ago" }}
              </span>
               <v-span v-else>{{ " - " }}</v-span>
             </td>

             <td>
               <span v-if="props.item.gps_status == 1">{{ "Enable" }}</span>
               <span v-else-if="props.item.gps_status == 0">{{ "Disable" }}</span>
               <span v-else>{{ " - " }}</span>
             </td>

             <td>
              <span v-if="props.item.tracking_time">
                <v-icon color="red"
                v-if="moment.duration(moment(moment().format('YYYY/MM/DD HH:mm:ss')).diff(moment(props.item.tracking_time, 'YYYY/MM/DD HH:mm:ss'))).asMinutes() > 15">
                  fiber_manual_record</v-icon>
                <v-icon color="green" v-else>fiber_manual_record</v-icon>
              </span>
               <span v-else>{{"-"}}
<!--                 <v-icon color="red">fiber_manual_record</v-icon>-->
               </span>
             </td>

           </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>


    <v-snackbar
        v-model="snackbar.display"
        :color="snackbar.color"
        :top="snackbar.top"
        :bottom="snackbar.bottom"
        :left="snackbar.left"
        :right="snackbar.right"
        :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <v-btn text dark @click="snackbar.display = false">
        <v-icon right color="white"> close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</div>
</template>

<script>
import moment from 'moment'
export default {
    name: "Index",
    watch: {
      pagination: {
        handler() {
          this.getRakeList();
        },
      },
      "filters.rakeNumber": function (val) {
        if (val == null || val == undefined || val == "") {
          this.isLoading = true;
          this.getRakeList();
        }
      },
      "filters.agency_code": function (val) {
        if (val != null) {
          this.isLoading = true;
          this.getRakeList();
        } else if (val == null || val == undefined || val == "") {
          this.isLoading = true;
          this.getRakeList();
        }
      },
      "filters.Carshed": function (val) {
        if (val != null) {
          this.isLoading = true;
          this.getRakeList();
        } else if (val == null || val == undefined || val == "") {
          this.isLoading = true;
          this.getRakeList();
        }
      },
      list: function (val) {
        if (val.length != 0) {
          this.list.forEach((item) => {
            if ((item.latitude != null || item.latitude != '') && (item.longitude != null || item.longitude != '')) {
              if (item.rake_address == '' && item.latitude != '0' && item.longitude != '0') {
                axios
                    .get('https://nominatim.openstreetmap.org/reverse?lat=' + item.latitude
                        + '&lon='
                        + item.longitude + '&zoom=14&format=json')
                    .then((response) => {
                      item.rake_address = response.data.display_name;
                      return item;
                    })
                    .catch((error) => {
                    });
              } else {
                item.rake_address = " - ";
                return item;
              }
            }
          })
        }
      },
    },
    data() {
      return {
        rake_number: "",
        pageLoader: false,
        search: "",
        options: {},
        sortDesc: false,
        selected: "",
        pagination: {
          // sortBy: "tracking_time",
          descending: true,
          rowsPerPage: 10,
        },
        headers1: [
          {text: "Number", value: "rake_number", filterable: true},
          {text: "Base Location", value: "base_location", sortable: false},
          {text: "Current Location", value: "rake_address", sortable: false},
          {text: "Train Status", value: "train_status", sortable: false},
          {text: "Tracking time", value: "tracking_time", sortable: true},
          {text: "GPS Status", value: "gps_status", sortable: false},
          {text: "Action", value: "action"},
        ],
        list: [],
        total_items: 0,
        loader: false,
        snackbar: {
          message: "",
          display: false,
          color: "black",
          top: true,
          right: true,
          bottom: false,
          left: false,
          timeout: 2000,
        },
        filters: {
          rakeNumber: "",
          Carshed: 'ALL',
          agency_code: '',
        },
        search_name: "",
        base_location: [{}],
        agency_code: [],
        searchingItem: false,
        searchingNumber: false,
        loaders: {
         rake_list: false,
        },
      };
    },
    methods: {
      getRakeList() {
        this.loaders.rake_list = true;
        this.list = [];
        this.searchingItem = true;
        this.searchingNumber = true;
        this.pagination.filters = Object.assign({}, this.filters);
        axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/fetch-rake-list`, {
              params: this.pagination,
              headers: this.$headers,
            })
            .then((response) => {
              if (response.data.status == 1) {
                this.loaders.rake_list = false;
                this.list = response.data.data.data;
                this.total_items = response.data.data.total;
                this.searchingItem = false;
                this.searchingNumber = false;
              } else if (response.data.status == 0) {
                this.loaders.rake_list = false;
                this.snackbar.message = response.data.message;
                this.snackbar.display = true;
                this.searchingItem = false;
                this.searchingNumber = false;

              }
            })
            .catch((error) => {
              console.log(error);
              this.snackbar.message = "Something went wrong";
              this.snackbar.display = true;
            });
      },
      getBaseLocationList() {
        this.pageLoader = true;
        axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/rake/get-base-location`)
            .then((response) => {
              if (response.data.status == 1) {
                this.pageLoader = false;
                this.base_location = response.data.data;
                this.base_location.push({carshed: 'ALL'})
                return this.base_location.sort((a, b) => {
                  if (a.carshed < b.carshed) return -1;
                  if (a.carshed > b.carshed) return 1;
                  return 0;
                });

              } else if (response.data.status == 0) {
                this.pageLoader = false
                this.snackbar.message = response.data.message;
                this.snackbar.display = true;
              }
            })
            .catch((error) => {
              this.pageLoader = false
              this.snackbar.message = "Something went wrong";
              this.snackbar.display = true;
            });
      },
      getAgencyCode() {
        this.pageLoader = true;
        axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/rake/get-rake-agency-code`)
            .then((response) => {
              if (response.data.status == 1) {
                this.pageLoader = false;
                this.agency_code = response.data.data;

              } else if (response.data.status == 0) {
                this.pageLoader = false
                this.snackbar.message = response.data.message;
                this.snackbar.display = true;
              }
            })
            .catch((error) => {
              this.pageLoader = false
              this.snackbar.message = "Something went wrong";
              this.snackbar.display = true;
            });
      },
    },
    mounted() {
      this.getBaseLocationList();
      this.getAgencyCode();
    }
  };
</script>

<style scoped>
</style>
